@if (header) {
    <div
        class="header-wrapper"
        [class.header-wrapper-flat]="!grouping"
        [class.subheader-wrapper-group]="gridEventDisplayOverride && grouping !== groupingType.None"
        (click)="toggleGroup()">
        @if (checkGroup(group, 'League')) {
            <ms-league-header
                [league]="group"
                [sportId]="sportId"
                [hideFavourites]="hideFavourites"
                [competitionFallbackIcon]="competitionFallbackIcon"
                [hideHeaderRegion]="hideHeaderRegion" />
        } @else if (checkGroup(group, 'Date')) {
            <ms-date-header [group]="group" />
        } @else if (checkGroup(group, 'HomeForm') || checkGroup(group, 'AwayForm') || checkGroup(group, 'OverallForm')) {
            <ms-form-header [form]="group" />
        }
        @if (group.collapsible && group.collapsed) {
            @if (!hideGroupCount) {
                <div class="header-count">{{ group.count }}</div>
            }
            <div class="header-toggle">
                <vn-icon name="theme-down" size="16" />
            </div>
        } @else {
            @if (!hideMarketHeader && options && !hideGroupHeader) {
                @for (column of columns; track column.id) {
                    @if (activeGroup(column); as active) {
                        <ms-group-header [group]="active" />
                    }
                }
            }
        }
    </div>
}
@if (!group.collapsed) {
    <ng-content />
}
